import Links from '@/shared/constants/navegacao';
import Loading from '@/shared/components/Carregando';
import { readEstagiarioForAttendanceSheetSelect } from '@/modules/people/estagiario.service';
import { toast } from 'react-toastify';
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

export default function EstagiarioMinhasFolhasPage() {
  const navigate = useNavigate();
  const startedRef = useRef(false);

  useEffect(() => {
    if (startedRef.current) return;
    startedRef.current = true;

    void readEstagiarioForAttendanceSheetSelect()
      .then(([estagiarios]) => {
        const estagiarioId = estagiarios[0]?.id;
        if (estagiarioId) {
          navigate(`${Links.Folha_Frequencia_Index}/${estagiarioId}`, { replace: true });
          return;
        }
        toast.warn('Nenhuma folha encontrada para o seu cadastro.');
        navigate(Links.Auth_Logout, { replace: true });
      })
      .catch(() => {
        toast.error('Não foi possível carregar suas folhas.');
        navigate(Links.Auth_Logout, { replace: true });
      });
  }, [navigate]);

  return <Loading />;
}
